import { Sentry } from './sentry';

export type PerformanceResource = 'dashboard-page' | 'dashboard-summary' | 'record' | 'search' | 'institution-metadata' | 'institution-logo' | 'dashboard';
export type PerformanceMetric = 'request' | 'cache-hit' | 'refresh-error' | 'first-content' | 'load';

/** Only bounded labels and timings cross this boundary, never URLs or user data. */
export function recordPerformance(name: PerformanceMetric, resource: PerformanceResource, durationMs = 0) {
  const duration = Math.max(0, durationMs);
  const detail = { name, resource, duration_ms: duration };
  window.dispatchEvent(new CustomEvent('vedra:performance', { detail }));
  // Manual spans use the existing configured trace sampling cap (at most 5%).
  const span = Sentry.startInactiveSpan({
    name: `vedra.${name}`, op: 'ui.vedra',
    startTime: (Date.now() - duration) / 1000,
    attributes: { resource, duration_ms: duration },
  });
  span.end();
}
